// extracted by css-extract-rspack-plugin
export default {"wrap":"src-components-NotesControl-NotesControl-module__wrap-ywChXl","btn":"src-components-NotesControl-NotesControl-module__btn-gTV9sI","dot":"src-components-NotesControl-NotesControl-module__dot-yFmGul"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"wrap\":\"src-components-NotesControl-NotesControl-module__wrap-ywChXl\",\"btn\":\"src-components-NotesControl-NotesControl-module__btn-gTV9sI\",\"dot\":\"src-components-NotesControl-NotesControl-module__dot-yFmGul\"}";
        // 1793732290095
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  